import { useState } from 'react';

export default function Contact() {
  const [form, setForm] = useState({ name: '', phone: '', message: '' });
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!form.name || !form.phone || !form.message) return;
    if (form.message.length > 500) return;
    setStatus('loading');
    try {
      const body = new URLSearchParams({
        name: form.name,
        phone: form.phone,
        message: form.message,
      });
      const res = await fetch('https://readdy.ai/api/form/d7c0nliqofe8vli40s30', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      if (res.ok) {
        setStatus('success');
        setForm({ name: '', phone: '', message: '' });
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  return (
    <section id="iletisim" className="py-24 md:py-32 bg-[#0A2540]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="text-xs font-semibold tracking-widest text-[#60A5FA] uppercase">İletişim</span>
          <h2 className="text-3xl md:text-4xl font-bold text-white mt-3 mb-4">
            Birlikte Değerlendirelim
          </h2>
          <p className="text-white/60 text-sm max-w-md mx-auto leading-relaxed">
            Sorularınız için bize ulaşın. En kısa sürede size dönüş yapacağız.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Info */}
          <div className="flex flex-col gap-6">
            {[
              { icon: 'ri-map-pin-line', label: 'Adres', value: 'Aydınlı Mah. Mayıs Sok. Adres Lobi Sitesi\nB Blok No:2B/4 Tuzla/İstanbul' },
              { icon: 'ri-phone-line', label: 'Telefon', value: '0 530 095 32 30' },
              { icon: 'ri-mail-line', label: 'E-posta', value: 'info@ozgurcakmak.com.tr' },
              { icon: 'ri-time-line', label: 'Çalışma Saatleri', value: 'Pzt–Cum: 09:00–18:00' },
            ].map((item) => (
              <div key={item.label} className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-xl flex-shrink-0">
                  <i className={`${item.icon} text-white text-base`}></i>
                </div>
                <div>
                  <div className="text-white/50 text-xs mb-1">{item.label}</div>
                  <div className="text-white text-sm whitespace-pre-line">{item.value}</div>
                </div>
              </div>
            ))}

            {/* WhatsApp */}
            <a
              href="https://wa.me/905300953230"
              target="_blank"
              rel="nofollow noreferrer"
              className="flex items-center gap-3 px-5 py-3 bg-[#25D366] text-white text-sm font-semibold rounded-xl hover:-translate-y-0.5 transition-all cursor-pointer whitespace-nowrap w-fit"
            >
              <i className="ri-whatsapp-line text-lg"></i>
              WhatsApp ile Yaz
            </a>
          </div>

          {/* Form */}
          <div className="lg:col-span-1">
            <form
              onSubmit={handleSubmit}
              data-readdy-form
              id="contact-form"
              className="bg-white/5 border border-white/10 rounded-2xl p-6 flex flex-col gap-4"
            >
              <div>
                <label className="text-white/60 text-xs mb-1.5 block">Ad Soyad</label>
                <input
                  type="text"
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  required
                  placeholder="Adınız Soyadınız"
                  className="w-full bg-white/10 border border-white/15 text-white placeholder-white/30 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:border-white/40 transition-colors"
                />
              </div>
              <div>
                <label className="text-white/60 text-xs mb-1.5 block">Telefon</label>
                <input
                  type="tel"
                  name="phone"
                  value={form.phone}
                  onChange={handleChange}
                  required
                  placeholder="+90 5XX XXX XX XX"
                  className="w-full bg-white/10 border border-white/15 text-white placeholder-white/30 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:border-white/40 transition-colors"
                />
              </div>
              <div>
                <div className="flex justify-between mb-1.5">
                  <label className="text-white/60 text-xs">Mesajınız</label>
                  <span className="text-white/30 text-xs">{form.message.length}/500</span>
                </div>
                <textarea
                  name="message"
                  value={form.message}
                  onChange={handleChange}
                  required
                  maxLength={500}
                  rows={4}
                  placeholder="Danışmak istediğiniz konu..."
                  className="w-full bg-white/10 border border-white/15 text-white placeholder-white/30 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:border-white/40 transition-colors resize-none"
                ></textarea>
              </div>

              {status === 'success' && (
                <div className="flex items-center gap-2 p-3 bg-emerald-500/20 border border-emerald-500/30 rounded-lg">
                  <i className="ri-checkbox-circle-line text-emerald-400"></i>
                  <span className="text-emerald-300 text-sm">Mesajınız iletildi. En kısa sürede dönüş yapacağız.</span>
                </div>
              )}
              {status === 'error' && (
                <div className="p-3 bg-rose-500/20 border border-rose-500/30 rounded-lg">
                  <span className="text-rose-300 text-sm">Bir hata oluştu. Lütfen tekrar deneyin.</span>
                </div>
              )}

              <button
                type="submit"
                disabled={status === 'loading' || form.message.length > 500}
                className="w-full py-3 bg-white text-[#0A2540] text-sm font-semibold rounded-lg hover:bg-white/90 transition-colors cursor-pointer whitespace-nowrap disabled:opacity-60"
              >
                {status === 'loading' ? 'Gönderiliyor...' : 'Mesaj Gönder'}
              </button>
            </form>
          </div>

          {/* Map */}
          <div className="rounded-2xl overflow-hidden h-[380px] lg:h-auto">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3011.8!2d29.3262!3d40.8968!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14b55f2e2e2e2e2f%3A0x4d6e7a8b9c0d1e2f!2sDumankaya%20Adres%20Lobi%20Sitesi!5e0!3m2!1str!2str!4v1713200000000!5m2!1str!2str"
              width="100%"
              height="100%"
              style={{ border: 0, minHeight: '300px' }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Ofis Konumu - Dumankaya Adres Lobi Sitesi Tuzla"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
}
